<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" v-if="hasAdd" @click="$router.push('/warehouse/add')">新增</el-button>
      </template>
      <el-form :model="searchForm" ref="formData" inline class="global-form-label-width account-form"
        label-width="100px">
        <el-form-item label="仓库名称" prop='warehouseName'>
          <el-input clearable v-model="searchForm.warehouseName" placeholder="仓库名称" />
        </el-form-item>
        <el-form-item label="仓库类型" prop="managerType">
          <el-select v-model="searchForm.managerType" :clearable="true">
            <el-option :label="value" :value="key" v-for="([key, value], index) of Array.from(managerTypeMap)"
              :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column min-width="200" :show-overflow-tooltip="true" label="仓库名称" prop="warehouseName"></el-table-column>
        <el-table-column min-width="200" :show-overflow-tooltip="true" label="仓库性质" prop="warehouseType">
          <template v-slot="{ row }">
            {{ row.warehouseType === '1' ? '内库' : row.warehouseType === '2' ? '外库' : '--' }}
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="仓库类型" prop="managerType">
          <template v-slot="{ row }">
            {{ managerTypeMap.get(row.managerType) || '-' }}
          </template>
        </el-table-column>
        <el-table-column min-width="200" :show-overflow-tooltip="true" label="所属公司" prop="company"></el-table-column>
        <el-table-column min-width="200" :show-overflow-tooltip="true" label="序号" prop="warehouseCode"></el-table-column>
        <el-table-column min-width="200" :show-overflow-tooltip="true" label="仓库编码" prop="warehouseNo"></el-table-column>
        <el-table-column min-width="200" :show-overflow-tooltip="true" label="省市区" prop="warRegion"></el-table-column>
        <el-table-column min-width="200" :show-overflow-tooltip="true" label="详细地址" prop="warAddress"></el-table-column>
        <!-- <el-table-column min-width="200" :show-overflow-tooltip="true" label="备用字段2" prop="byzdA2"></el-table-column> -->
        <el-table-column min-width="200" :show-overflow-tooltip="true" label="邮编" prop="warPostcode"></el-table-column>
        <el-table-column min-width="200" :show-overflow-tooltip="true" label="仓库管理员" prop="managerName"></el-table-column>
        <el-table-column min-width="200" :show-overflow-tooltip="true" label="操作时间" prop="ctime"></el-table-column>

        <el-table-column width="160" label="操作" fixed="right">
          <template v-slot="{ row }">
            <template>
              <el-button type="text" @click="$router.push('/warehouse/detail?warehouseId=' + row.warehouseId)">详情</el-button>
              <el-button type="text" v-if="hasEdit" @click=" $router.push('/warehouse/edit?warehouseId=' + row.warehouseId)">编辑</el-button>
              <el-button class="del-btn" type="text" v-if="hasDelete" @click="deleteRow(row.warehouseId)">删除</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import { managerType } from '@/utils/dict'
import keepAlive from '@/mixins/keepAlive'
export default {
  name: 'Warehouse',
  mixins: [keepAlive],
  data() {
    return {
      managerTypeMap: managerType,
      tableData: [],
      page: 1,
      total: 0,
      loading: false,
      searchForm: {
        warehouseName: '',
        managerType: ''
      }
    }
  },
  created() {
    this.loadData()
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasDelete() {
      return this.buttonList.includes('delete')
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasAdd() {
      return this.buttonList.includes('add')
    }
  },
  methods: {
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.prodManage.selectLyWarehouseByPage, {
        page: this.page,
        size: 10,
        ...this.searchForm
      }).then(res => {
        this.tableData = res.list
        this.total = res.total
      }).finally(() => {
        this.loading = false
      })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onReset() {
      this.$refs.formData.resetFields()
      this.onSearch()
    },
    deleteRow(warehouseId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.prodManage.deleteLyWarehouse, {
          warehouseId
        }).then(() => {
          this.loadData()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'>
// .el-select {
//   width: 100%;
// }</style>
<style lang='scss'>
.account-form {

  .el-select,
  .el-input,
  .el-cascader {
    width: 200px !important;
  }
}
</style>
